import { branch, compose, setDisplayName, renderComponent } from 'recompose';
import Layout from './Layout';
import LayoutWithMeasurement from './LayoutWithMeasurement';

export default compose(setDisplayName('Layout'), branch(function (_ref) {
  var children = _ref.children;
  return typeof children === 'function';
}, renderComponent(LayoutWithMeasurement)))(Layout);


//////////////////
// WEBPACK FOOTER
// ../node_modules/@primitives/layout/build/web/index.js
// module id = 37
// module chunks = 0